import { createCrudApi } from '@core/api/createCrudApi';
import type { BaseEntity } from '@core/interfaces';

export interface Color extends BaseEntity {
  name: string;
  hexCode: string;
  sortOrder?: number;
}

export interface CreateColorData {
  name: string;
  hexCode: string;
}

export type UpdateColorData = Partial<CreateColorData>;

const colorApi = createCrudApi<Color, CreateColorData, UpdateColorData>(
  'color'
);

export const getAllColors = colorApi.getAll;
export const getColorById = colorApi.getById;
export const createColor = colorApi.create;
export const updateColor = colorApi.update;
export const deleteColor = colorApi.delete;
export const reorderColors = colorApi.reorder;
